import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import DeleteTeamModal from '../DeleteTeamModal/DeleteTeamModal';
import FatalError from '../FatalError/FatalError';
import { REQUEST } from '../../consts';
import { apiThunk, httpActions } from '../../actions';
import {
  getRequestInFlight,
  getRequestError,
} from '../../selectors/httpSelectors';

import { IAppState } from '../../types/state.d';
import { Occasion, OccasionType } from '../../../types/graphql';
import { getOccasion } from '../../selectors/apiSelectors';

type Props = MapStateToProp & MapDispatchToProps;

export const DeleteTeam = ({
  deleteTeam,
  isError,
  isInFlight,
  occasion,
  resetRequestError,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <form data-qa="delete-team-form">
      <h2 className="jg-space-mbsm">
        {t(['content.settings.delete.heading', 'Delete team page'])}
      </h2>
      <p className="jg-text--large jg-space-mbsm">
        {t([
          'content.settings.delete.subtext',
          'If you don’t need your team page anymore, you can permanently delete it.',
        ])}
      </p>
      <div className="row">
        <div className="jg-space-pbmd col-lg-6">
          <button
            data-qa="delete-team"
            className="jg-btn jg-btn--ghost jg-space-mbms jg-space-mtsm jg-space-mtn@lg"
            onClick={() => setIsModalOpen(true)}
            aria-haspopup="true"
            type="button"
          >
            {t(['content.settings.button.deleteteam', 'Delete team page'])}
          </button>
        </div>
      </div>
      <DeleteTeamModal
        deleteTeam={deleteTeam}
        onCloseModal={() => setIsModalOpen(false)}
        isModalOpen={isModalOpen}
        isInFlight={isInFlight}
        isInMemory={occasion?.type === OccasionType.InMemory}
      />
      {isError && <FatalError closeButtonClick={resetRequestError} />}
    </form>
  );
};

type MapStateToProp = {
  isInFlight?: boolean;
  isError: boolean;
  occasion?: Occasion;
};

type MapDispatchToProps = {
  deleteTeam: typeof apiThunk.deleteTeam;
  resetRequestError: typeof httpActions.resetRequestError;
};

const mapStateToProps = (state: IAppState): MapStateToProp => ({
  isInFlight: getRequestInFlight(REQUEST.DELETE_TEAM)(state),
  isError: getRequestError(REQUEST.DELETE_TEAM)(state),
  occasion: getOccasion(state)
});

const mapDispatchToProps: MapDispatchToProps = {
  deleteTeam: apiThunk.deleteTeam,
  resetRequestError: httpActions.resetRequestError,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteTeam);
